webpackJsonp([23],{

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentTable_vue__ = __webpack_require__(2763);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6962c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentTable_vue__ = __webpack_require__(4439);
function injectStyle (ssrContext) {
  __webpack_require__(4425)
  __webpack_require__(4427)
  this["$style"] = __webpack_require__(4429)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b6962c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6962c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assocFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchManualSaveTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return returnForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return completeForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {};

var formRules = {
  customerid: [{ required: true, message: '客户ID不能为空', trigger: 'blur' }],
  receipt_info_id: [{ required: true, message: '抬头不能为空', trigger: 'blur' }],
  desc: [{ required: true, message: '申请描述不能为空', trigger: 'blur' }],
  type: [{ required: true, message: '发票类别不能为空', trigger: 'blur' }],
  subject: [{ required: true, message: '开票主体不能为空', trigger: 'blur' }],
  currency_type: [{ required: true, message: '币种不能为空', trigger: 'blur' }],
  bd: [{ required: true, message: '预收款开票 bd 不能为空', trigger: 'blur' }],
  bu_approver: [{ required: true, message: 'BU审批不能为空', trigger: 'blur' }],
  attached_file: [{ required: true, message: '附件不能为空', trigger: 'blur' }],
  po_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入30字以内的单号', 'string', 'blur', false), { max: 29 })],
  pay_condition_id: [{ required: true, message: '请选择账期', trigger: 'blur' }]
};

var assocFormRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款', 'integer'))],
  assoc_amount: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款金额', 'string'))]
};

var searchManualSaveTicket = {
  fpdm: [{ required: true, message: '发票代码不能为空', trigger: 'blur' }],
  fphm: [{ required: true, message: '发票号码不能为空', trigger: 'blur' }],
  kprq: [{ required: true, message: '开票日期不能为空', trigger: 'blur' }]
};

var returnForm = {
  isCurrentMonth: [{ required: true, message: '请选择是否当月发票', trigger: 'blur' }],
  reason: [{ required: true, message: '退票原因不能为空', trigger: 'blur' }],
  redAttachedFile: [{ required: true, message: '红冲发票附件不得为空', trigger: 'blur' }]
};

var completeForm = {
  invoice_number: [{ required: true, message: '发票号码不能为空', trigger: 'blur' }, { max: 255, message: '发票号码不得大于255个字符', trigger: 'blur' }],
  invoice_code: [{ required: true, message: '发票代码不能为空', trigger: 'blur' }, { max: 255, message: '发票代码不得大于255个字符', trigger: 'blur' }],
  invoice_time: [{ required: true, message: '开票日期不得为空', trigger: 'blur' }],
  e_invoice_url: [{ required: true, message: '电子发票链接不得为空', trigger: 'blur' }]
};

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false
    };
  },

  methods: {
    selectRemoteMethod: function selectRemoteMethod(query, request, callback, params) {
      var _this = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          request(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyword: query }, params)).then(function (response) {
            callback(response.data);
          }).finally(function () {
            _this.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    }
  }
});

/***/ }),

/***/ 1932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */]],
  props: {
    scope: Object
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  })),
  methods: {
    approveInvoice: function approveInvoice(id) {
      this.$emit('approveInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    confirmInvoice: function confirmInvoice(id) {
      this.$emit('confirmInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    returnInvoice: function returnInvoice(id) {
      this.$emit('returnInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    abandonInvoice: function abandonInvoice(id) {
      this.$emit('abandonInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    isShowReturnBtn: function isShowReturnBtn(item) {
      // 已开票，已签收状态，且发起人 显示退票按钮
      return [6, 7].includes(item.status * 1) && item.initiator * 1 === this.user.id * 1;
    }
  }
});

/***/ }),

/***/ 2118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forceFinishRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })],
  customerid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户名称', 'integer'))],
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款类型', 'integer'))],
  receipt_info_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户名称', 'integer'))],
  desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款描述', 'string'))],
  our_company_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择收款公司', 'integer'))],
  our_company_account_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择收款账户', 'integer'))],
  collection_amount: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款金额', 'string'))],
  received_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款日期', 'string'))],
  // mail_to: [
  //   {...makeRule('请选择收件人', 'array')},
  // ],
  // memo: [
  //   {...makeRule('请输入回款备注', 'string')},
  // ],
  attached_file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传附件', 'array'))]
};

var forceFinishRules = {
  reason: [{ required: true, message: '核销说明不能为空', trigger: 'blur' }]
};

/***/ }),

/***/ 2165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationButtons_vue__ = __webpack_require__(1932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede2fd50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationButtons_vue__ = __webpack_require__(2166);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede2fd50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-gutter',[((_vm.scope.row.status === 3 || _vm.scope.row.status === 1) && parseInt(_vm.user.id) === _vm.scope.row.initiator)?_c('router-link',{attrs:{"to":'/invoice-apply/update/'+_vm.scope.row.id}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("修改\n      ")])],1):_vm._e(),_vm._v(" "),([1, 3].includes(parseInt(_vm.scope.row.status)) && parseInt(_vm.user.id) === parseInt(_vm.scope.row.initiator))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.abandonInvoice(_vm.scope.row.id)}}},[_vm._v("放弃\n      ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 1 && parseInt(_vm.user.id) === _vm.scope.row.bu_approver)?_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.approveInvoice(_vm.scope.row.id)}}},[_vm._v("BO审批\n      ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 6 && parseInt(_vm.user.id) === _vm.scope.row.initiator)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.confirmInvoice(_vm.scope.row.id)}}},[_vm._v("客户签收\n      ")]):_vm._e(),_vm._v(" "),(_vm.isShowReturnBtn(_vm.scope.row))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.returnInvoice(_vm.scope.row.id)}}},[_vm._v("申请退票\n      ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invoice_apply_rules_js__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_mixins_selectRemote__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_invoice_apply_components_OperationButtons__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_invoice_apply_components_ReceivedSummaryDialog__ = __webpack_require__(4431);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__core_mixins_selectRemote__["a" /* default */]],
  components: {
    OperationButtons: __WEBPACK_IMPORTED_MODULE_7__views_invoice_apply_components_OperationButtons__["a" /* default */],
    ReceivedSummaryDialog: __WEBPACK_IMPORTED_MODULE_8__views_invoice_apply_components_ReceivedSummaryDialog__["a" /* default */]
  },
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_3__invoice_apply_rules_js__["f" /* searchRules */],
      search: {
        received_payment_status: null,
        customerid: null,
        projectid: null,
        bu_approver: null,
        initiator: null,
        created_at: [],
        received_payment_time: [],
        sort_by_received_payment_time: null,
        sort_by_id: null,
        desc: null,
        total_amount_min: null,
        total_amount_max: null
      },
      searchFieldType: {
        received_payment_status: Number,
        customerid: String,
        projectid: String,
        bu_approver: Number,
        initiator: Number
      },
      selectLoading: false,
      customerItems: [],
      projectItems: [],
      adminuserItems: [],
      exportHeader: [{
        key: 'id',
        text: '开票申请ID'
      }, {
        key: 'subject_name',
        text: '开票主体'
      }, {
        key: 'customer_number',
        text: '客户编号'
      }, {
        key: 'customer_name',
        text: '客户名称'
      }, {
        key: 'company_name',
        text: '公司名称'
      }, {
        key: 'project_number',
        text: '项目编号'
      }, {
        key: 'project_name',
        text: '项目名称'
      }, {
        key: 'bu_name',
        text: 'BO审批'
      }, {
        key: 'initiator_name',
        text: '发起人'
      }, {
        key: 'invoice_time',
        text: '开票日期'
      }, {
        key: 'invoice_number',
        text: '发票号码'
      }, {
        key: 'untaxed_amount',
        text: '未税开票金额'
      }, {
        key: 'total',
        text: '含税开票金额'
      }, {
        key: 'total_received_amount',
        text: '已回款金额'
      }, {
        key: 'unreceived_amount',
        text: '未回款金额'
      }, {
        key: 'received_payment_status',
        text: '回款状态'
      }, {
        key: 'received_payment_time',
        text: '回款日期'
      }, {
        key: 'received_amount',
        text: '回款金额'
      }, {
        key: 'received_payment_desc',
        text: '回款备注'
      }, {
        key: 'do_number',
        text: 'DO/PO单号'
      }, {
        key: 'desc',
        text: '申请描述'
      }, {
        key: 'created_at',
        text: '创建时间'
      }, {
        key: 'updated_at',
        text: '更新时间'
      }],
      dialogType: null,
      title: null,
      receivedSummary: [],
      summaryVisible: false,
      titlePrefix: '开票申请 - '
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.invoiceApply.options;
    }
  })),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getProjectTable', 'getPlatformUsersDetail']), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getReceivedPaymentTable', params);
    },
    sortChange: function sortChange(column, prop, order) {
      this.search.sort_by_id = this.search.sort_by_received_payment_time = null;
      var sortBy = 'asc';
      if (column.order === 'descending') {
        sortBy = 'desc';
      }
      if (column.prop === 'id') {
        this.search.sort_by_id = sortBy;
      } else if (column.prop === 'received_payment_time') {
        this.search.sort_by_received_payment_time = sortBy;
      }
      this.onSearch();
    },
    getExportData: function getExportData(params) {
      return request.page('exportReceivedPayment', params);
    },
    onExportPage: function onExportPage() {
      this.$export(this.$route.name + '-' + this.pagination.current_page + 'P', this.table, {
        fileHeader: this.exportHeader
      });
    },
    onExportSearch: function onExportSearch() {
      var _this = this;

      this.$export(this.$route.name, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data = _this.handleExportData(data.data);
          return data;
        }
      });
    },
    handleExportData: function handleExportData(data) {
      var _this2 = this;

      data.forEach(function (row) {
        _this2.options.received_payment_status.forEach(function (status) {
          if (status.value === row.received_payment_status) {
            row.received_payment_status = status.label;
          }
        });
      });
      return data;
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      return request.common('getCustomerTable', { keyword: query.name, type: [10, 70] });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote() {
      return request.common('getCustomerDetail', { id: this.search.customerid });
    },
    customerLabel: function customerLabel(item) {
      return item.name + '/' + item.number;
    },
    projectRemoteMethod: function projectRemoteMethod(query) {
      return request.common('getProjectTable', { keyword: query.name });
    },
    getProjectInfoRemote: function getProjectInfoRemote() {
      return request.common('getProjectDetail', { id: this.search.projectid });
    },
    openReceivedSummaryDialog: function openReceivedSummaryDialog() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.receivedSummary = [];
                _context.next = 3;
                return request.common('getReceivedSummary', Object(__WEBPACK_IMPORTED_MODULE_5__core_mixins_table__["c" /* removeEmptyParams */])(_this3.search)).then(function (data) {
                  var totalTaxedAmount = 0;
                  var totalReceivedAmount = 0;
                  var totalUnreceivedAmount = 0;
                  for (var i in data.data) {
                    if (data.data.hasOwnProperty(i)) {
                      totalTaxedAmount += data.data[i].total;
                      totalReceivedAmount += data.data[i].received_amount;
                      totalUnreceivedAmount += data.data[i].unreceived_amount;
                      _this3.receivedSummary.push(data.data[i]);
                    }
                  }
                  if (totalTaxedAmount) {
                    _this3.receivedSummary.push({
                      'status': -1, // -1 为 总计 列，需单独处理显示文字
                      'total': totalTaxedAmount,
                      'received_amount': totalReceivedAmount,
                      'unreceived_amount': totalUnreceivedAmount
                    });
                  }
                  _this3.title = '回款统计';
                  _this3.summaryVisible = true;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    adminuserRemoteMethod: function adminuserRemoteMethod(query) {
      return request.common('getPlatformUsersIndex', query);
    },
    getAdminUserInfoRemote: function getAdminUserInfoRemote() {
      return request.common('getPlatformUsersDetail', { id: this.search.bu_approver });
    },
    openDetail: function openDetail(id) {
      this.$router.push('/invoice-apply/detail/' + id + '?type=detail');
    }
  })
});

/***/ }),

/***/ 2764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: Boolean,
    title: String,
    receivedSummary: Array
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.invoiceApply.options;
    }
  })),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 2953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__received_payment_rules_js__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__received_payment_mixins__ = __webpack_require__(5325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_received_payment_components_PaymentSummaryDialog__ = __webpack_require__(5326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_received_payment_components_ForceFinishDialog__ = __webpack_require__(5334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PaymentSummaryDialog: __WEBPACK_IMPORTED_MODULE_5__views_received_payment_components_PaymentSummaryDialog__["a" /* default */], ForceFinishDialog: __WEBPACK_IMPORTED_MODULE_6__views_received_payment_components_ForceFinishDialog__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__received_payment_mixins__["a" /* default */]],
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_1__received_payment_rules_js__["c" /* searchRules */],
      search: {
        id: null,
        customerid: null,
        created_at: [],
        received_date: [],
        creator_id: null,
        collection_amount_min: null,
        collection_amount_max: null,
        desc: null,
        our_company_id: null,
        receipt_related_status: null,
        receipt_info_id: null,
        is_from_finance: this.$route.meta.type === 'approval' ? 1 : 0
      },
      searchFieldType: {
        received_payment_status: Number,
        creator_id: Number,
        receipt_info_id: Number
      },
      paymentCompanies: {},
      paymentSummary: [],
      summaryVisible: false,
      currentCollection: {},
      forceFinishVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    collectionTypeText: function collectionTypeText(state) {
      return state.receivedPayment.collectionTypeText;
    }
  }), {
    routerPath: function routerPath() {
      return 'received-' + this.$route.meta.type;
    },
    isApprovePage: function isApprovePage() {
      return this.$route.meta.type === 'approval';
    }
  }),
  created: function created() {
    this.getFinCenterConfigs();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), request.map(['getCustomerReceiptDetail']), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getNewReceivedPaymentTable', params);
    },
    getReceivedPaymentSummary: function getReceivedPaymentSummary(params) {
      return request.page('getReceivedPaymentSummary', params);
    },
    onExportSearch: function onExportSearch() {
      var _this = this;

      this.$export('回款明细导出-' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HHmmss'), {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data.forEach(function (item) {
            item.type_txt = _this.collectionTypeText[item.type];
            item.received_company = _this.paymentCompanies[item.our_company_id];
            item.received_date = _this.formatOnlyDate(item.received_date);
            item.receipt_related_status = _this.receiptRelatedStatus[item.receipt_related_status];
            item.received_bank_info = item.company_bank_info.name + '/' + item.company_bank_info.number;
            item.customer_number = item.customer_name + '/' + item.customer_number;
          });
          return data;
        }
      });
    },
    onExportRelatedDetail: function onExportRelatedDetail() {
      var _this2 = this;

      this.$export('回款核销明细-' + __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HHmmss'), {
        fileHeader: this.exportRelatedHeader,
        total: this.pagination.total,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request.page('exportCollectionRelatedDetail', params);
        }),
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          data.data.forEach(function (item) {
            item.type_txt = _this2.collectionTypeText[item.type];
            item.received_company = _this2.paymentCompanies[item.our_company_id];
            item.received_date = _this2.formatOnlyDate(item.received_date);
            item.receipt_related_status = _this2.receiptRelatedStatus[item.receipt_related_status];
            item.received_bank_info = item.company_bank_info.name + '/' + item.company_bank_info.number;
            item.customer_number = item.customer_name + '/' + item.customer_number;
          });
          return data;
        }
      });
    },
    showSummaryVisible: function showSummaryVisible() {
      var _this3 = this;

      request.page('getReceivedPaymentSummary', Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["b" /* removeEmptyParams */])(this.search)).then(function (_ref) {
        var data = _ref.data;

        _this3.paymentSummary = data;
        _this3.summaryVisible = true;
      });
    },
    getFinCenterConfigs: function getFinCenterConfigs() {
      var _this4 = this;

      return request.common('getFinCenterConfigs').then(function (_ref2) {
        var data = _ref2.data;

        _this4.setupPaymentCompany(data);
      });
    },
    setupPaymentCompany: function setupPaymentCompany(data) {
      this.paymentCompanies = data.payment_apply_our_company_source.reduce(function (o, k) {
        o[k.id] = k.name;
        return o;
      }, {});
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      return request.common('getCustomerTable', { keyword: query.name, type: [10, 70] });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote() {
      return request.common('getCustomerDetail', { id: this.search.customerid });
    },
    receiptInfoForRemote: function receiptInfoForRemote(query) {
      return request.common('receiptInfoForRemoteSearch', { keyword: query.company_name });
    },
    showForceFinish: function showForceFinish(row) {
      this.currentCollection = row;
      this.forceFinishVisible = true;
    },
    closeForceFinishDialog: function closeForceFinishDialog() {
      this.currentCollection = {};
      this.forceFinishVisible = false;
    },
    getRemovedEmptySearch: function getRemovedEmptySearch() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["b" /* removeEmptyParams */])(_.cloneDeep(this.search));
    },
    exportCollectionList: function exportCollectionList() {
      var _this5 = this;

      var searchParams = this.getRemovedEmptySearch();
      this.getTableData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, searchParams, { per_page: 1 })).then(function (res) {
        if (res.data.total === 0) {
          _this5.$alert('当前查询条件下没有回款数据，请调整搜索条件后再导出数据', '提示', { type: 'warning' });
          return;
        }
        _this5.$confirm('确定导出回款列表数据？', '提示', { type: 'warning' }).then(function () {
          request.common('exportCollectionListApi', _this5.getRemovedEmptySearch()).then(function (res) {
            _this5.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', { type: 'success' }).then(function () {
              _this5.$router.push({ path: '/batch-jobs/finance-export-jobs' });
            });
          });
        });
      });
    },
    exportCollectionDetail: function exportCollectionDetail() {
      var _this6 = this;

      var searchParams = this.getRemovedEmptySearch();
      this.getTableData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, searchParams, { per_page: 1 })).then(function (res) {
        if (res.data.total === 0) {
          _this6.$alert('当前查询条件下没有回款数据，请调整搜索条件后再导出数据', '提示', { type: 'warning' });
          return;
        }
        _this6.$confirm('确定导出回款核销明细数据？', '提示', { type: 'warning' }).then(function () {
          request.common('exportCollectionDetailApi', _this6.getRemovedEmptySearch()).then(function (res) {
            _this6.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', { type: 'success' }).then(function () {
              _this6.$router.push({ path: '/batch-jobs/finance-export-jobs' });
            });
          });
        });
      });
    },
    fetchOurCompanies: function fetchOurCompanies(params) {
      return request.common('getFinCenterOurCompaniesTable', params);
    },
    getOurCompaniesDetail: function getOurCompaniesDetail(id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(function (data) {
        data.data.id = String(data.data.id);
        return data;
      });
    }
  })
});

/***/ }),

/***/ 2954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: Boolean,
    title: String,
    data: Array
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 2955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__received_payment_rules_js__ = __webpack_require__(2118);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: Boolean,
    collectionData: Object
  },
  data: function data() {
    return {
      id: 0,
      forceFinishRules: __WEBPACK_IMPORTED_MODULE_2__received_payment_rules_js__["a" /* forceFinishRules */],
      body: {
        reason: null,
        attached_file: []
      },
      fileList: [],
      current_collection: {},
      loadingFileUpload: false
    };
  },

  computed: {},
  watch: {
    collectionData: {
      handler: function handler(val) {
        this.current_collection = val;
        this.id = val.id;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    handleExceed: function handleExceed(files, fileList, max) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 ' + max + ' \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    beforeRemove: function beforeRemove(file, fileList, formField) {
      var fileTemp = void 0;
      if (file.raw) {
        fileTemp = file.raw;
      } else {
        fileTemp = file;
      }
      var index = this.getFileListIndex(fileTemp, fileList);
      if (index > -1) {
        formField.splice(index, 1);
      }
    },
    getFileListIndex: function getFileListIndex(file, fileList) {
      for (var i = 0; i < fileList.length; i++) {
        var fileTemp = void 0;
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw;
        } else {
          fileTemp = fileList[i];
        }
        if (file === fileTemp) {
          return i;
        }
      }
      return -1;
    },
    onChangeFile: function onChangeFile(file, fileList, formField) {
      var isLt5M = file.raw.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error('文件内容必须小于50MB!');
        this.$refs.upload.uploadFiles.pop();
        return false;
      }
      this.onUploadFile(file.raw, fileList, formField);
    },
    onUploadFile: function onUploadFile(file, fileList, formField) {
      var _this = this;

      this.loadingFileUpload = true;

      var formData = new FormData();
      formData.append('file', file);
      this.id && formData.append('apply_id', this.id);
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(function (_ref) {
        var data = _ref.data;

        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        var index = _this.getFileListIndex(file, fileList);

        var type = file.name.split('.').pop().toLowerCase();
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic';
        } else if (['pdf'].includes(type)) {
          type = 'pdf';
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml';
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office';
        } else if (['zip'].includes(type)) {
          type = 'zip';
        }
        if (index > -1) {
          formField[index] = { name: file.name, url: data, type: type };
        }
        _this.loadingFileUpload = false;
      }).catch(function (_) {
        _this.$refs.upload.uploadFiles.pop();
        _this.loadingFileUpload = false;
      });
    },
    closeDialog: function closeDialog() {
      this.id = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$emit('closeDialog');
    },
    closeAndRefresh: function closeAndRefresh() {
      this.closeDialog();
      this.$emit('refreshPage');
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['body'].validate(function (valid) {
        if (valid) {
          var confirmText = ['请确认操作当前特殊核销', '\u56DE\u6B3EID\uFF1A' + _this2.current_collection.id, '\u5F85\u6838\u9500\u91D1\u989D\uFF1A' + _this2.current_collection.remain_amount_total, '\u5DF2\u6838\u9500\u91D1\u989D\uFF1A' + _this2.current_collection.related_amount_total];
          var newMsg = [];
          var h = _this2.$createElement;
          for (var i in confirmText) {
            newMsg.push(h('p', null, confirmText[i]));
          }
          _this2.$confirm('', '确认特殊核销', {
            message: h('div', null, newMsg),
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(function () {
            request.common('forceFinishCollection', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: _this2.id }, _.cloneDeep(_this2.body))).then(function (res) {
              _this2.$confirm('特殊核销成功', '提示', { type: 'success' }).then(function () {
                _this2.closeAndRefresh();
              }, function () {
                _this2.closeAndRefresh();
              });
            });
          }, function () {
            _this2.closeDialog();
          });
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentTable_vue__ = __webpack_require__(2953);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7785194a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentTable_vue__ = __webpack_require__(5342);
function injectStyle (ssrContext) {
  __webpack_require__(5319)
  __webpack_require__(5321)
  this["$style"] = __webpack_require__(5323)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7785194a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedPaymentTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7785194a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedPaymentTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4425:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4426);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7a00c527", content, true, {});

/***/ }),

/***/ 4426:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4427:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("30b9db3e", content, true, {});

/***/ }),

/***/ 4428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4429:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a5b82ac6", content, true, {});

/***/ }),

/***/ 4430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedSummaryDialog_vue__ = __webpack_require__(2764);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f17ab4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedSummaryDialog_vue__ = __webpack_require__(4438);
function injectStyle (ssrContext) {
  __webpack_require__(4432)
  __webpack_require__(4434)
  this["$style"] = __webpack_require__(4436)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f17ab4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceivedSummaryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f17ab4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceivedSummaryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4432:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4433);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0041df7e", content, true, {});

/***/ }),

/***/ 4433:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4434:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5823c17a", content, true, {});

/***/ }),

/***/ 4435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4436:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4437);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("05f46d70", content, true, {});

/***/ }),

/***/ 4437:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"before-close":_vm.closeDialog,"width":"50%"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.receivedSummary,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.received_payment_status),function(item){return (scope.row.received_payment_status * 1 === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),_vm._v(" "),(scope.row.status * 1 === -1)?_c('span',[_vm._v("总计")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"含税开票汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.total,2))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"received_amount","label":"已回款汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.received_amount,2))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unreceived_amount","label":"未回款汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.unreceived_amount,2))+"\n      ")]}}])})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.name),expression:"$route.name"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),(_vm.$route.params.type==='10')?_c('el-breadcrumb-item',[_vm._v("客户管理")]):_vm._e(),_vm._v(" "),(_vm.$route.params.type==='1')?_c('el-breadcrumb-item',[_vm._v("财务管理")]):_vm._e(),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.name))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"customerid"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"number","keyword-key":"name","label":_vm.customerLabel,"value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":_vm.customerRemoteMethod,"find-request":_vm.getCustomerInfoRemote},on:{"change":function($event){_vm.search.projectid=null}},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"number","keyword-key":"name","label":_vm.customerLabel,"value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":_vm.projectRemoteMethod,"find-request":_vm.getProjectInfoRemote},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款状态","prop":"received_payment_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.received_payment_status),callback:function ($$v) {_vm.$set(_vm.search, "received_payment_status", $$v)},expression:"search.received_payment_status"}},_vm._l((_vm.options.received_payment_status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"BO审批","prop":"bu_approver"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.bu_approver),callback:function ($$v) {_vm.$set(_vm.search, "bu_approver", $$v)},expression:"search.bu_approver"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款日期","prop":"received_payment_time"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.received_payment_time),callback:function ($$v) {_vm.$set(_vm.search, "received_payment_time", $$v)},expression:"search.received_payment_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"申请描述","prop":"desc"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入申请描述关键字搜索"},model:{value:(_vm.search.desc),callback:function ($$v) {_vm.$set(_vm.search, "desc", $$v)},expression:"search.desc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票金额"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"total_amount_min"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额起始值"},model:{value:(_vm.search.total_amount_min),callback:function ($$v) {_vm.$set(_vm.search, "total_amount_min", $$v)},expression:"search.total_amount_min"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('div',[_vm._v("  至  ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"prop":"total_amount_max"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额结束值"},model:{value:(_vm.search.total_amount_max),callback:function ($$v) {_vm.$set(_vm.search, "total_amount_max", $$v)},expression:"search.total_amount_max"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发起人","prop":"initiator"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.initiator),callback:function ($$v) {_vm.$set(_vm.search, "initiator", $$v)},expression:"search.initiator"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"sj-icon-export"},on:{"click":function($event){return _vm.onExportPage()}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("按搜索结果导出\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.openReceivedSummaryDialog}},[_vm._v("按搜索结果汇总\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""},on:{"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","sortable":"custom","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"desc","label":"申请描述","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.openDetail(scope.row.id)}}},[_vm._v("\n            "+_vm._s(scope.row.desc)+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"客户编号","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.customer_name)+"/"+_vm._s(scope.row.customer_number)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"company_name","label":"公司名称","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"received_payment_status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.received_payment_status),function(item){return (scope.row.received_payment_status === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"含税开票金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.currency_type),function(item){return (scope.row.currency_type === item.value)?_c('span',[_vm._v(_vm._s(item.symbol))]):_vm._e()}),_vm._v("\n          "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.total,2))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"received_amount","label":"已回款金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.currency_type),function(item){return (scope.row.currency_type === item.value)?_c('span',[_vm._v(_vm._s(item.symbol))]):_vm._e()}),_vm._v("\n          "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.received_amount,2))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"未回款金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.currency_type),function(item){return (scope.row.currency_type === item.value)?_c('span',[_vm._v(_vm._s(item.symbol))]):_vm._e()}),_vm._v("\n          "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.unreceived_amount,2))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiator_name","label":"发起人","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bu_name","label":"BO审批","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"received_payment_time","label":"回款日期","sortable":"custom","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"230"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/invoice-apply/received-payment-detail/" + (scope.row.id) + "/type/" + (_vm.$route.params.type) + "?currency_type=" + (scope.row.currency_type))}},[_c('el-button',{attrs:{"size":"mini"}},[_vm._v("查看\n            ")])],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('received-summary-dialog',{attrs:{"visible":_vm.summaryVisible,"receivedSummary":_vm.receivedSummary,"title":_vm.title},on:{"closeDialog":function($event){_vm.summaryVisible=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5319:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("00433f50", content, true, {});

/***/ }),

/***/ 5320:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5321:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5322);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7c4eb148", content, true, {});

/***/ }),

/***/ 5322:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5323:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5324);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("323a81bc", content, true, {});

/***/ }),

/***/ 5324:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ReceivedPaymentTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      fields: [{
        prop: 'id',
        label: 'ID',
        width: 80
      }, {
        prop: 'desc',
        label: '回款描述',
        minWidth: 120
      }, {
        prop: 'customer_number',
        label: '客户编号',
        minWidth: 160,
        formatter: function formatter(row) {
          return row.customer_name + '/' + row.customer_number;
        }
      }, {
        prop: 'receipt_info_company_name',
        label: '公司名称',
        minWidth: 120
      }, {
        prop: 'our_company_id',
        label: '收款公司',
        minWidth: 120,
        formatter: function formatter(row) {
          return _this.paymentCompanies[row.our_company_id];
        }
      }, {
        prop: 'type',
        label: '回款类型',
        minWidth: 90,
        formatter: function formatter(row) {
          return _this.collectionTypeText[row.type];
        }
      }, {
        prop: 'collection_amount',
        label: '回款金额',
        minWidth: 120
      }, {
        prop: 'received_date',
        label: '回款日期',
        minWidth: 120,
        formatter: function formatter(row) {
          return _this.formatOnlyDate(row.received_date);
        }
      }, {
        prop: 'receipt_related_status',
        label: '核销状态',
        minWidth: 120,
        formatter: function formatter(row) {
          return _this.receiptRelatedStatus[row.receipt_related_status];
        }
      }, {
        prop: 'remain_amount_total',
        label: '待核销金额',
        minWidth: 120
      }, {
        prop: 'related_amount_total',
        label: '已核销金额',
        minWidth: 120
      }, {
        prop: 'creator_name',
        label: '发起人',
        minWidth: 120
      }, {
        prop: 'created_at',
        label: '创建时间',
        minWidth: 120
      }],
      exportHeader: [{
        key: 'id',
        text: '回款ID'
      }, {
        key: 'desc',
        text: '回款描述'
      }, {
        key: 'customer_number',
        text: '客户编号'
      }, { key: 'receipt_info_id', text: '开票抬头ID' }, {
        key: 'receipt_info_company_name',
        text: '公司名称'
      }, {
        key: 'received_company',
        text: '回款公司'
      }, {
        key: 'received_bank_info',
        text: '收款账户/银行账号'
      }, { key: 'type_txt', text: '回款类型' }, {
        key: 'collection_amount',
        text: '回款金额'
      }, {
        key: 'received_date',
        text: '回款日期'
      }, {
        key: 'receipt_related_status',
        text: '核销状态'
      }, { key: 'related_amount_total', text: '已核销金额' }, {
        key: 'remain_amount_total',
        text: '待核销金额'
      }, {
        key: 'creator_name',
        text: '发起人'
      }, {
        key: 'created_at',
        text: '创建时间'
      }],
      exportSummaryHeader: [{
        key: 'received_total',
        text: '回款ID'
      }, {
        key: 'cnt',
        text: '回款笔数'
      }, {
        key: 'remain_total',
        text: '已核销金额'
      }, {
        key: 'related_total',
        text: '待核销金额'
      }],
      exportRelatedHeader: [{ key: 'id', text: '回款ID' }, { key: 'desc', text: '回款描述' }, { key: 'customer_number', text: '客户编号' }, { key: 'receipt_info_id', text: '开票抬头ID' }, { key: 'receipt_info_company_name', text: '公司名称' }, { key: 'received_company', text: '回款公司' }, { key: 'received_bank_info', text: '收款账户/银行账号' }, { key: 'type_txt', text: '回款类型' }, { key: 'collection_amount', text: '回款金额' }, { key: 'received_date', text: '回款日期' }, { key: 'receipt_related_status', text: '核销状态' }, { key: 'assoc_amount', text: '已核销金额' }, { key: 'receipt_apply_id', text: '开票ID' }, { key: 'creator_name', text: '发起人' }, { key: 'created_at', text: '创建时间' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    receiptRelatedStatus: function receiptRelatedStatus(state) {
      return state.receivedPayment.receiptRelatedStatus;
    },
    collectionTypeText: function collectionTypeText(state) {
      return state.receivedPayment.collectionTypeText;
    }
  })),
  methods: {
    formatOnlyDate: filter.formatOnlyDate
  }
});

/***/ }),

/***/ 5326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSummaryDialog_vue__ = __webpack_require__(2954);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72eaf102_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSummaryDialog_vue__ = __webpack_require__(5333);
function injectStyle (ssrContext) {
  __webpack_require__(5327)
  __webpack_require__(5329)
  this["$style"] = __webpack_require__(5331)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72eaf102"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSummaryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72eaf102_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSummaryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5327:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5328);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6b9efb60", content, true, {});

/***/ }),

/***/ 5328:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5329:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5330);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4fcdf4f8", content, true, {});

/***/ }),

/***/ 5330:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5331:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5332);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("07584ad6", content, true, {});

/***/ }),

/***/ 5332:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaymentSummaryDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"before-close":_vm.closeDialog,"width":"50%"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"received_total","label":"回款金额汇总","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.received_total,2))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cnt","label":"回款笔数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"related_total","label":"已开票金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.related_total,2))+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remain_total","label":"待开票金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.remain_total,2))+"\n      ")]}}])})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("关闭")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForceFinishDialog_vue__ = __webpack_require__(2955);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ef7b46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForceFinishDialog_vue__ = __webpack_require__(5341);
function injectStyle (ssrContext) {
  __webpack_require__(5335)
  __webpack_require__(5337)
  this["$style"] = __webpack_require__(5339)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23ef7b46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForceFinishDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ef7b46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForceFinishDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5335:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("744d33e3", content, true, {});

/***/ }),

/***/ 5336:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ForceFinishDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5337:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5338);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("937e8876", content, true, {});

/***/ }),

/***/ 5338:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ForceFinishDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5339:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5340);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6b3cd3d9", content, true, {});

/***/ }),

/***/ 5340:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ForceFinishDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"特殊核销","visible":_vm.visible,"before-close":_vm.closeDialog,"width":"50%"}},[_c('el-form',{ref:"body",attrs:{"label-width":"96px","model":_vm.body,"rules":_vm.forceFinishRules,"label-position":"right","size":"medium"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"prop":"reason","label":"核销说明","min-width":"120"}},[_c('el-input',{attrs:{"placeholder":"请输入核销说明"},model:{value:(_vm.body.reason),callback:function ($$v) {_vm.$set(_vm.body, "reason", $$v)},expression:"body.reason"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"附件","prop":"attached_file"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (file, fileList) {_vm.onChangeFile(file, fileList, this$1.body.attached_file)},"before-remove":function (file, fileList) {_vm.beforeRemove(file, fileList, this$1.body.attached_file)},"multiple":"","limit":20,"on-exceed":function (file, fileList) {_vm.handleExceed(file, fileList, 20)},"file-list":_vm.fileList,"accept":".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"点击上传附件","placement":"right"}},[_c('el-button',{attrs:{"size":"small","loading":_vm.loadingFileUpload,"type":"primary"}},[_vm._v("点击上传\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式\n          ")])],1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.loadingFileUpload},on:{"click":_vm.onSubmit}},[_vm._v("确认\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("回款管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"rules":_vm.searchRules,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"回款ID","prop":"id"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入回款ID搜索"},model:{value:(_vm.search.id),callback:function ($$v) {_vm.$set(_vm.search, "id", $$v)},expression:"search.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称","prop":"customerid"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"number","keyword-key":"name","label":function (item) {return item.name + '/' + item.number},"value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":_vm.customerRemoteMethod,"find-request":_vm.getCustomerInfoRemote},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户开票信息","prop":"receipt_info_id"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"company_name","label-key":"company_name","value-key":"id","placeholder":"请输入开票信息名称/ID搜索","query-request":_vm.receiptInfoForRemote,"find-request":_vm.getCustomerReceiptDetail},model:{value:(_vm.search.receipt_info_id),callback:function ($$v) {_vm.$set(_vm.search, "receipt_info_id", $$v)},expression:"search.receipt_info_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款金额"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"collection_amount_min"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额起始值"},model:{value:(_vm.search.collection_amount_min),callback:function ($$v) {_vm.$set(_vm.search, "collection_amount_min", $$v)},expression:"search.collection_amount_min"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('div',[_vm._v("  至  ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"prop":"collection_amount_max"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额结束值"},model:{value:(_vm.search.collection_amount_max),callback:function ($$v) {_vm.$set(_vm.search, "collection_amount_max", $$v)},expression:"search.collection_amount_max"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款描述","prop":"desc"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入回款描述关键字搜索"},model:{value:(_vm.search.desc),callback:function ($$v) {_vm.$set(_vm.search, "desc", $$v)},expression:"search.desc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发起人","prop":"creator_id"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"收款公司","prop":"our_company_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"仅支持搜索启用中的收款公司,可输入名称进行搜索","query-request":function (_){ return _vm.fetchOurCompanies(Object.assign(_, {is_disabled: 0})); },"find-request":_vm.getOurCompaniesDetail},model:{value:(_vm.search.our_company_id),callback:function ($$v) {_vm.$set(_vm.search, "our_company_id", $$v)},expression:"search.our_company_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"核销状态","prop":"receipt_related_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.receipt_related_status),callback:function ($$v) {_vm.$set(_vm.search, "receipt_related_status", $$v)},expression:"search.receipt_related_status"}},_vm._l((_vm.receiptRelatedStatus),function(value,key){return _c('el-option',{key:key,attrs:{"label":value,"value":key}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款时间","prop":"received_date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.received_date),callback:function ($$v) {_vm.$set(_vm.search, "received_date", $$v)},expression:"search.received_date"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[(_vm.isApprovePage)?_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"},on:{"click":function($event){return _vm.$router.push(("/" + _vm.routerPath + "/create"))}}},[_vm._v("新增回款\n      ")]):_vm._e(),_vm._v(" "),(this.$route.query.old_export)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.onExportSearch()}}},[_vm._v("回款列表导出\n      ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":function($event){return _vm.exportCollectionList()}}},[_vm._v("回款列表导出\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.showSummaryVisible()}}},[_vm._v("按搜索结果汇总\n      ")]),_vm._v(" "),(this.$route.query.old_export)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.onExportRelatedDetail()}}},[_vm._v("回款核销明细导出\n      ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":function($event){return _vm.exportCollectionDetail()}}},[_vm._v("回款核销明细导出\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.fields),function(attr,index){return [_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","width":_vm.isApprovePage ? 170 : 80,"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"button-gutter"},[_c('button-gutter',[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push(("/" + _vm.routerPath + "/detail/" + (scope.row.id)))}}},[_vm._v("查看\n              ")]),_vm._v(" "),(_vm.isApprovePage && scope.row.receipt_related_status===0)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.$router.push(("/" + _vm.routerPath + "/update/" + (scope.row.id)))}}},[_vm._v("修改\n              ")]):_vm._e(),_vm._v(" "),(_vm.isApprovePage && scope.row.receipt_related_status!==2)?_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.showForceFinish(scope.row)}}},[_vm._v("特殊核销\n              ")]):_vm._e()],1)],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('payment-summary-dialog',{attrs:{"title":"回款统计","visible":_vm.summaryVisible,"data":_vm.paymentSummary},on:{"closeDialog":function($event){_vm.summaryVisible = false}}}),_vm._v(" "),_c('force-finish-dialog',{attrs:{"visible":_vm.forceFinishVisible,"collectionData":_vm.currentCollection},on:{"refreshPage":function($event){return _vm.onRefresh()},"closeDialog":_vm.closeForceFinishDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/received-payment-table.2e914f667f9863b1b3fb.js